import TableList from "@components/templates/tablelist";
import comIndex from './update';
import { mapState, mapGetters } from "vuex";
import {
    HttpGetOutboundConfigList
} from '@/service/storageallocation';
export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // 'quanbu': 0,
                    // 'IN_orderStatus':null,
                }
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        }
    },
   
    computed: {
        ...mapGetters("dictionary", [
            "getOrgList",
            "getBillcusorgList",
            "getBillcusAndFbaWareList",
        ]),
        ToolsData() {
            return [
                {
                    name: "添加配置",
                    operate: "add",
                    theme: "primary",
                }
            ]
        },
        SearchsData() {
            let style = 'width: 130px;';
            return [
                {
                    label: "客户",
                    tag: 'Select',
                    key: 'EQ_organizationId',
                    options: this.getBillcusorgList,
                    show: true,
                    style: style,
                    props: {
                        filterable: true,
                    }
                },
               
            ]
        },
        columns() {
            return [{
                title: '操作',
                width: 70,
                render: this.getOperateNodes,
                // fixed: 'left'
            }, {
                title: '客户',
                key: 'organizationId',
                sortable: true,
                render: (h, { row }) => {
                    let orgName = this.getBillcusorgList.filter(item => {
                        return item.value === row.organizationId
                    })[0] || '--';
                    if (orgName !== '--') {
                        orgName = orgName.label;
                    }
                    return <div>{orgName}</div>
                }
                
            } ,{
                title: '出库系数',
                key: 'orgCoefficient'
            },{
                title: '日期区间',
                render: (h, { row }) => {
                    let dateBetween = row.startDate+"~"+row.endDate
                    return <div>{dateBetween}</div>
                }
            } ,{
                title: '更新时间',
                key: 'updatedAt',
                sortable:true,
            }]
        }
    },
    methods: {
        ajaxRequest: HttpGetOutboundConfigList,
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: '查看',
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: '编辑',
                    show: true,
                    params: id,
                    operate: 'edit'
                }]
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'add': {
                    let url = this.$router.resolve({
                        name: "outboundConfigUpdate",
                        params: { type: "add" },
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'query': {
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        type: 'query',
                        showFooter: false
                    }
                    break;
                }
                case 'edit': {
                    let url = this.$router.resolve({
                        name: "outboundConfigUpdate",
                        params: { type: "edit" },
                        query: {
                            id: params
                        }
                    });
                    window.open(url.href, '_blank');
                    break;
                }
               
            }
        }
    }
}